import * as XLSX from 'sheetjs-style';
import * as FileSaver from 'file-saver';

class EventHelper {
    static export = (record, registrations, params) => {
        let content = record.contents.filter(content => content.language === params.language)[0];
        if (!content) content = record.contents[0];

        let workbook = {
            Sheets: {
                'registrations': XLSX.utils.json_to_sheet(registrations.map(registration => this.convertToExportRecord(registration, params)))
            },
            SheetNames: ['registrations']
        };

        let buffer = XLSX.write(workbook, { bookType: 'xlsx', type: 'array' });
        let blob = new Blob([buffer], { type: 'application/vnd.openxmlformats-officedocument.spreadsheetml.sheet;charset=UTF-8' });

        FileSaver.saveAs(blob, params.intl.formatMessage({ id: 'CMS.Event.registrations.export.file_name' }, { event: params.filename.trim().toLowerCase().replace(' ', '-') }));
    }

    static convertToExportRecord = (registration, params) => {
        let content = registration.period?.contents.filter(content => content.language === params.language)[0];
        if (!content) content = registration.period.contents[0];

        // Set general data
        let record = {
            [params.intl.formatMessage({ id: 'CMS.Event.registrations.export.header.id' })]: registration.id,
            [params.intl.formatMessage({ id: 'CMS.Event.registrations.export.header.created' })]: registration.created_at.format('DD/MM/YYYY HH:mm:ss'),
            [params.intl.formatMessage({ id: 'CMS.Event.registrations.export.header.payment_status' })]: registration.status ? params.intl.formatMessage({ id: 'CMS.Event.registrations.export.header.payment_status.' + registration.status }) : null,
            [params.intl.formatMessage({ id: 'CMS.Event.registrations.export.header.period' })]: content.title,
            [params.intl.formatMessage({ id: 'CMS.Event.registrations.export.header.attendee.last_name' })]: registration.attendee?.last_name,
            [params.intl.formatMessage({ id: 'CMS.Event.registrations.export.header.attendee.first_name' })]: registration.attendee?.first_name
        };

        if (params.settings.event.use_options) {
            record[params.intl.formatMessage({ id: 'CMS.Event.registrations.export.header.options' })] = registration.optionsLabel();
            record[params.intl.formatMessage({ id: 'CMS.Event.registrations.export.header.base_price' })] = registration.price !== null && registration.price !== undefined ? registration.basePrice() : null;
            record[params.intl.formatMessage({ id: 'CMS.Event.registrations.export.header.price' })] = registration.price !== null && registration.price !== undefined ? parseFloat(registration.price) : null;
        }

        if (params.settings.attendee.fields.email) {
            record[params.intl.formatMessage({ id: 'CMS.Event.registrations.export.header.attendee.email' })] = registration.attendee?.email;
        }
        if (params.settings.attendee.fields.phone) {
            record[params.intl.formatMessage({ id: 'CMS.Event.registrations.export.header.attendee.phone' })] = registration.attendee?.phone;
        }
        if (params.settings.attendee.fields.birth_date) {
            record[params.intl.formatMessage({ id: 'CMS.Event.registrations.export.header.attendee.birth_date' })] = registration.attendee?.birth_date;
        }
        if (params.settings.attendee.fields.gender) {
            record[params.intl.formatMessage({ id: 'CMS.Event.registrations.export.header.attendee.gender' })] = registration.attendee?.gender ? params.intl.formatMessage({ id: 'CMS.Attendee.Content.Form.gender.' + registration.attendee?.gender }) : null;
        }
        if (params.settings.attendee.fields.national_insurance_number) {
            record[params.intl.formatMessage({ id: 'CMS.Event.registrations.export.header.attendee.national_number' })] = registration.attendee?.national_insurance_number;
        }
        if (params.settings.attendee.fields.medical_info) {
            record[params.intl.formatMessage({ id: 'CMS.Event.registrations.export.header.attendee.medical_info' })] = registration.attendee?.medical_info;
        }

        params.settings.attendee.additionalFields.forEach(field => {
            if (field.field_type === 'select') {
                record[field.contents[0]?.label] = field.options.find(o => parseInt(o.id) === parseInt(registration.attendee.additionalFieldValues[field.field_key]))?.contents[0]?.label;
            } else {
                record[field.contents[0]?.label] = registration.attendee.additionalFieldValues[field.field_key];
            }
        });

        // Client
        record[params.intl.formatMessage({ id: 'CMS.Event.registrations.export.header.client.last_name' })] = registration.client.last_name;
        record[params.intl.formatMessage({ id: 'CMS.Event.registrations.export.header.client.first_name' })] = registration.client.first_name;
        record[params.intl.formatMessage({ id: 'CMS.Event.registrations.export.header.client.email' })] = registration.client.email;

        if (params.settings.client.fields.phone) {
            record[params.intl.formatMessage({ id: 'CMS.Event.registrations.export.header.client.phone' })] = registration.client.phone;
        }
        if (params.settings.client.fields.gender) {
            record[params.intl.formatMessage({ id: 'CMS.Event.registrations.export.header.client.gender' })] = registration.client.gender ? params.intl.formatMessage({ id: 'CMS.Attendee.Content.Form.gender.' + registration.client.gender }) : null;
        }

        if (params.settings.client.fields.billing_address) {
            record[params.intl.formatMessage({ id: 'CMS.Event.registrations.export.header.client.street' })] = registration.client.billing_address.street;
            record[params.intl.formatMessage({ id: 'CMS.Event.registrations.export.header.client.number' })] = registration.client.billing_address.number;
            record[params.intl.formatMessage({ id: 'CMS.Event.registrations.export.header.client.box' })] = registration.client.billing_address.box;
            record[params.intl.formatMessage({ id: 'CMS.Event.registrations.export.header.client.postal' })] = registration.client.billing_address.postal;
            record[params.intl.formatMessage({ id: 'CMS.Event.registrations.export.header.client.city' })] = registration.client.billing_address.city;
            record[params.intl.formatMessage({ id: 'CMS.Event.registrations.export.header.client.country' })] = registration.client.billing_address.country;
        }

        return record;
    }
}

export default EventHelper;